export default "__VITE_ASSET__BeqU8bAT__"